<template>
  <header id="header" ref="homeHeight" v-view="inHome">
    <div id="particles">
      <div class="intro">
        <h1 style="font-family: monospace">Shamsiar Hamid</h1>
        <h5>Passionate about changing the world with technology.</h5>
        <hr
          style="width: 50%; background-color: #e83951; border-color: #e83951"
        />
        <vue-typed-js
          :strings="[
            'Full-Stack Web Developer',
            'Wordpress Developer',
            'Freelancer',
          ]"
          :type-speed="100"
          :back-speed="100"
          :loop="true"
          :cursor-char="'_'"
        >
          <h4 style="" class="span-typing"><span class="typing" /></h4>
        </vue-typed-js>
      </div>
      <div class="bottom">
        <a
          data-scroll
          href="#navigation"
          class="scrollDown animated pulse"
          id="scrollToContent"
        >
          <i class="pe-7s-angle-down-circle pe-va rainbow"></i
        ></a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  mounted() {
    window.addEventListener("scroll", this.home_height);
  },
  methods: {
    home_height() {
      var height = this.$refs.homeHeight.clientHeight;
      this.$emit("home_height", height);
    },
    inHome() {
      this.$emit("inHome");
    },
  },
};
</script>

<style lang="scss" scoped></style>
<style scoped>
.typed-element {
  display: block;
}
</style>
